<template>
  <div class="list-page">
    <div class="school-title">{{ school_title }}</div>
    <div class="table-list">
      <el-card class="box-card" v-for="(item, index) in tableData" :key="index">
        <div slot="header" class="clearfix">
          <span>计划详情</span>
          <el-button style="float: right; padding: 3px 0; margin-left:10px" type="text"
            @click="selectList(item)">查看</el-button>
          <el-button style="float: right; padding: 3px 0; margin-left:10px" type="text"
            @click="exportList(item)">下载</el-button>
        </div>
        <div class="code-info">
          <p><strong>计划名称</strong>{{ item.plan_title }}</p>
          <p><strong>测评人次</strong>{{ item.evaluated_number }}</p>
          <p><strong>完成人数</strong>{{ item.evaluated_completed_number }}</p>
          <p><strong>未完成人数</strong>{{ item.not_evaluated_number }}</p>
          <p><strong>完成进度</strong>{{ item.completion_schedule }}</p>
        </div>
        <div class="code-info code-info-recheck">
          <p class="p-info">复检人数更新截至时间：{{ today }}</p>
          <p><strong>复检人数</strong>{{ item.recheck_total_number }}</p>
          <p><strong>未完成复检人数</strong>{{ item.recheck_not_complete_number }}</p>
          <p><strong>复检完成进度</strong>{{ item.recheck_schedule }}</p>
        </div>
      </el-card>

    </div>
    <el-dialog title="下载名单" :visible.sync="centerDialogVisible" width="80%" center>
      <span>
        <el-button el-button type="text" @click="exportClick(1)">未作答名单</el-button>
        <br>
        <el-button type="text" @click="exportClick(2)">异常作答名单</el-button>
        <br>
        <el-button type="text" @click="exportClick(4)">复检名单</el-button>
        <br>
        <el-button type="text" @click="exportClick(3)">复检未作答名单</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看名单" :visible.sync="selectDialogVisible" width="80%" center>
      <span>
        <el-button el-button type="text" @click="examine(1)">未作答名单</el-button>
        <br>
        <el-button type="text" @click="examine(2)">异常作答名单</el-button>
        <br>
        <el-button type="text" @click="examine(4)">复检名单</el-button>
        <br>
        <el-button type="text" @click="examine(3)">复检未作答名单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { APIEXPORTUNFINISH, APILOGIN, APIEXPORTEXCEPTIONDATA, APIGETEVALUTAIONPROGRESS } from "@/common/api.js"
import { getStorage } from "@/common/storage"
import downloadApi from "@/common/downloadApi"

export default {
  name: "List",
  data() {
    return {
      Api: '',
      tableData: [],
      loading: true,
      centerDialogVisible: false,
      selectDialogVisible: false,
      selectInfo: {},
      school_title: getStorage('school_title'),
      today: ""
    }
  },

  created() {
    this.Api = downloadApi
    this.tableList()
  },
  methods: {
    tableList() { // 表格
      APILOGIN({
        tel: getStorage('tel')
      }).then((res) => {
        if (res.status === 1) {
          this.loading = false
          this.tableData = res.data.list
          this.today = res.data.totay
        } else {
          this.$message.error(res.msg)
          this.InIt()
        }
      }).catch((err) => {
        this.$message.error(err.msg)
      })
    },
    selectList(val) {
      this.selectDialogVisible = true;
      this.selectInfo = val;
    },
    exportList(val) {
      this.centerDialogVisible = true;
      this.selectInfo = val;
    },
    // 进行下載跳转导出
    exportClick(val) {
      console.log(this.selectInfo);
      let href = this.Api + '/api/getEvaluationProgress' + '?school_id=' + this.selectInfo.school_id + '&plan_id=' + this.selectInfo.id + '&status=' + val + "&export=1&limit=" + this.selectInfo.not_evaluated_number + "&token=" + getStorage('token')
      //  console.log(href);
      window.location.href = href
      //进行获取连接
      // APIEXPORTUNFINISH({
      //   token:getStorage('token'),
      //   school_id:this.selectInfo.school_id,
      //   plan_id:this.selectInfo.id,
      //   status:val
      // }).then((res)=>{
      //   let href  = this.Api + res.data.url + "?plan_info="+ res.data.plan_info + "&token="+ getStorage('token')
      //     window.location.href=href
      // }).catch((err) => {
      //   this.$message.error(err.msg)
      // })
    },
    // 下载异常作答名单
    abnormalClick() {

      APIEXPORTEXCEPTIONDATA({
        token: getStorage('token'),
        school_id: this.selectInfo.school_id,
        plan_id: this.selectInfo.id
      }).then((res) => {
        let href = this.Api + res.data.url + "?plan_info=" + res.data.plan_info + "&token=" + getStorage('token')
        // console.log(href);
        window.location.href = href
      }).catch((err) => {

        this.$message.error(err.msg)
      })
    },
    // 跳转至详情页
    examine(val) {
      console.log(this.selectInfo);
      if (val == 1) {
        this.$router.push({ path: '/studentList', query: { id: this.selectInfo.id } })
      } else if (val == 2) {
        this.$router.push({ path: '/abnormalStudentList', query: { id: this.selectInfo.id } })
      } else if (val == 3) {
        this.$router.push({ path: '/recheckList', query: { id: this.selectInfo.id } })
      } else if (val == 4) {
        this.$router.push({ path: '/recheckList1', query: { id: this.selectInfo.id } })
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.list-page {


  .school-title {
    background: #4c5bf7;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    text-align: center;
    width: 100%;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .table-list {
    padding: 0 10px 20px;
    box-sizing: border-box;
  }

  .box-card {
    margin-top: 10px;

    .code-info {
      &.code-info-recheck {
        border-top: 1px dashed #4c5bf7;
        margin-top: 10px;
        padding-top: 10px;

        p {
          padding-left: 140px;

          strong {
            width: 120px;
          }
        }
      }

      p {
        min-height: 28px;
        line-height: 28px;
        font-size: 14px;
        padding: 0;
        margin: 0;
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding-left: 100px;
        overflow: hidden;

        &.p-info {
          padding-left: 0 !important;
        }

        strong {
          position: absolute;
          left: 0;
          top: 0;
          display: inline-block;
          width: 80px;
          margin-right: 10px;
          text-align: justify;
          text-align-last: justify;
          /*兼容ie*/
          text-justify: distribute-all-lines;
        }
      }
    }
  }
}
</style>